/**
 * The few formatting helpers this app needs, house style (ui-design §3.13):
 * curly quotes, no em or en dashes in copy, a middle dot between clauses.
 * Copied from the dashboard's `lib/format.ts` rather than shared — a handful of
 * functions are not a package.
 */

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

/** "Aug 18, 2026" from an ISO instant. */
export function formatDay(timestamp: string | null | undefined): string {
  if (!timestamp) return '';
  const at = new Date(timestamp);
  if (Number.isNaN(at.getTime())) return '';
  return `${MONTHS[at.getMonth()] ?? ''} ${at.getDate()}, ${at.getFullYear()}`;
}

export function joinClauses(parts: (string | null | undefined)[]): string {
  return parts.filter((part): part is string => Boolean(part && part.length > 0)).join(' · ');
}

export function plural(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`;
}

/**
 * Micro-USD to "$41.20". Monitored, not capped: no warning colour anywhere.
 * Moved here from the dashboard on 2026-08-27 — spend is admin-plane only, so
 * this is now the only app that renders money.
 */
export function formatMoney(microUsd: number): string {
  return `$${(microUsd / 1_000_000).toFixed(2)}`;
}
